import React from "react";
import { Box, Heading, Text, SimpleGrid, Button, Flex } from "@chakra-ui/react";
import { motion } from "framer-motion";
import feasibilityBg from "../assets/detailedengg.jpg"; // Add hero background image

export default function ServicesFeasibility() {
  const MotionBox = motion(Box);

  const processSteps = [
    {
      title: "Site Assessment & Resource Analysis",
      description:
        "Evaluation of site conditions, including solar irradiance, wind speed, land availability, accessibility, and environmental constraints.",
    },
    {
      title: "Technology Selection & System Design Concepts",
      description:
        "Identification of the most suitable technology (e.g., PV, wind turbine specs, hybrid systems) and development of preliminary system layouts and sizing.",
    },
    {
      title: "Energy Yield Estimation",
      description:
        "Use of industry-standard tools to simulate expected generation, seasonal performance, and losses.",
    },
    {
      title: "Financial Modelling & Viability Assessment",
      description:
        "CAPEX/OPEX estimation, Levelized Cost of Energy (LCOE), IRR, NPV, and payback period calculations based on realistic assumptions.",
    },
    {
      title: "Reporting & Recommendations",
      description:
        "A detailed feasibility report summarizing findings, conclusions, and recommendations to guide project go/no-go decisions or investor presentations.",
    },
  ];

  return (
    <Box>
      <Box bg="#F5FAF6" color="#305D24">
        {/* Hero Section */}
        <Box
          position="relative"
          shadow="xl"
          mb={10}
          textAlign="center"
          overflow="hidden"
          minH={{ base: "300px", md: "350px" }}
        >
          <Box
            position="absolute"
            top={0}
            left={0}
            width="100%"
            height="100%"
            bgImage={`url(${feasibilityBg})`}
            bgSize="cover"
            bgPosition="center"
            filter="brightness(0.6) blur(2px)"
            zIndex={0}
          />
          <Box
            position="relative"
            zIndex={1}
            color="white"
            p={{ base: 10, md: 16 }}
          >
            <Heading
              fontSize={{ base: "3xl", md: "5xl" }}
              mb={4}
              textShadow="2px 2px 4px rgba(0,0,0,0.7)"
            >
              Feasibility Study
            </Heading>
            <Text
              fontSize={{ base: "md", md: "lg" }}
              mt={4}
              maxW="3xl"
              mx="auto"
              textShadow="1px 1px 3px rgba(0,0,0,0.6)"
              fontWeight="bold"
            >
              Evaluate renewable energy projects for technical, financial, and
              regulatory viability.
            </Text>
            <Text
              mt={2}
              maxW="3xl"
              mx="auto"
              textShadow="1px 1px 3px rgba(0,0,0,0.6)"
              fontWeight="bold"
            >
              We help clients make informed decisions by studying site
              conditions, energy output, technology options, costs, regulations,
              and potential risks.
            </Text>
          </Box>
        </Box>

        {/* Process Section */}
        <Box
          bg="#F5FAF6"
          rounded="2xl"
          p={{ base: 6, md: 12 }}
          mb={10}
          mx={{ base: 4, md: 20 }}
          textAlign="center"
        >
          <Heading
            size="xl"
            mb={10}
            fontSize={{ base: "2xl", md: "5xl" }}
            color="#305D24"
          >
            Our Process
          </Heading>
          <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={8}>
            {processSteps.map((step, i) => (
              <MotionBox
                key={i}
                p={6}
                bg="white"
                rounded="xl"
                shadow="md"
                whileHover={{ scale: 1.05 }}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.1, duration: 0.6 }}
              >
                <Heading size="md" mb={3} color="#519C36">
                  {step.title}
                </Heading>
                <Text fontSize="sm" color="gray.700">
                  {step.description}
                </Text>
              </MotionBox>
            ))}
          </SimpleGrid>
        </Box>

        {/* Call to Action */}
        <Flex justify="center" py={10}>
          <Button
            bg="#FBBF24"
            color="#065F46"
            size="lg"
            as="a"
            href="/contact"
            _hover={{ bg: "#F59E0B", transform: "scale(1.05)" }}
          >
            Start a Project
          </Button>
        </Flex>
      </Box>
    </Box>
  );
}
